import { render } from "./UserCommentSection.vue?vue&type=template&id=11806c54&scoped=true"
import script from "./UserCommentSection.vue?vue&type=script&lang=js"
export * from "./UserCommentSection.vue?vue&type=script&lang=js"

import "./UserCommentSection.vue?vue&type=style&index=0&id=11806c54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11806c54"]])

export default __exports__